const Share = {
  isPackageInstalled: () => true,
  open: () => null,
  openSingle: () => null,
}

export enum Social {
  Twitter = 'x',
  Whatsapp = 'whatsapp',
  Instagram = 'instagram',
  Sms = 'sms',
  Telegram = 'telegram',
  Snapchat = 'snapchat',
  Messenger = 'messenger',
  Viber = 'viber',
}

export default Share
